import { useNavigate } from 'react-router-dom';
import { FallbackProps } from 'react-error-boundary';
import { Trend } from '@antimatterhq/ui/components/trend';
import { Button } from '@antimatterhq/ui/components/button';
import { BaseHomepageSummaryCard } from '@/components/homepage/summaryCard/BaseHomepageSummaryCard';
import { HomepageSummaryCardMainMetric } from '@/components/homepage/summaryCard/HomepageSummaryCardMainMetric';
import { useGetAlertsSummary } from '@/hooks/dbui/useGetAlertsSummary';
import HomepageSummaryCardSkeleton from '@/pages/home/_partials/HomepageSummaryCardSkeleton';
import { DefaultErrorBoundaryFallback } from '@/components/errorBoundary/ErrorBoundary';

export const AlertsHomepageSummaryCard = () => {
  const { data } = useGetAlertsSummary();
  const navigate = useNavigate();

  return (
    <BaseHomepageSummaryCard title="Operational alerts" to={'/explore/health'}>
      <div className="grid grid-cols-3 gap-4">
        <HomepageSummaryCardMainMetric
          label="Open alerts"
          value={data?.currentlyOpen}
        />
        <Trend
          label="Total raised last 7 days"
          value={data?.alertsLast7days}
          trend={{
            startingValue: data?.alertsPreceding7days ?? 0,
            endingValue: data?.alertsLast7days ?? 0,
          }}
          summarizeCount
        />
        <Trend
          label="Total raised last 24 hours"
          value={data?.alertsLast24hours}
          trend={{
            startingValue: data?.alertsPreceding24hours ?? 0,
            endingValue: data?.alertsLast24hours ?? 0,
          }}
          summarizeCount
        />
      </div>
      <div className="mt-4 flex justify-end">
        <Button
          variant="default"
          leftIcon="lucide:folder-open"
          onClick={() => navigate('/explore/health?includeNotOpen=false')}
        >
          View open alerts
        </Button>
      </div>
    </BaseHomepageSummaryCard>
  );
};

export const AlertsHomepageSummaryCardSkeleton = () => (
  <HomepageSummaryCardSkeleton
    title="Operational alerts"
    subtitle="Open alerts"
    to="/explore/health"
    showStatus
    showActionButton
    actionButtonText="View open alerts"
    totalsMetric="raised"
  />
);

export const AlertsHomepageSummaryCardErrorFallback = (
  props: FallbackProps,
) => {
  return (
    <BaseHomepageSummaryCard title="Operational alerts" to="/explore/health">
      <DefaultErrorBoundaryFallback {...props} />
    </BaseHomepageSummaryCard>
  );
};
